import { RemoteImportPlacesFromAnotherGroup } from 'data/usecases';
import { ImportPlacesFromAnotherGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlImportPlacesFromAnotherGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteImportPlacesFromAnotherGroup =
  (): ImportPlacesFromAnotherGroupUseCaseInterface =>
    new RemoteImportPlacesFromAnotherGroup(
      makeApiUrlImportPlacesFromAnotherGroup(),
      makeAxiosHttpClient(),
    );
